import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import Notifications from 'vue-notification'
import VuePapaParse from 'vue-papa-parse'
import XLSX from 'xlsx'
import Vuelidate from 'vuelidate'

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'material-design-icons';
import 'material-design-icons/iconfont/material-icons.css'
import store from './store'
import VueAxios from 'vue-axios'
import { securedAxiosInstance, plainAxiosInstance } from './services/axios'
import i18n from './i18n'
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-EECZ9TDXTR" }
});
Vue.config.productionTip = false
Vue.use(VueAxios, {
  secured: securedAxiosInstance,
  plain: plainAxiosInstance
})
Vue.use(Notifications)
Vue.use(VuePapaParse)
Vue.use(XLSX)
Vue.use(Vuelidate)

/* eslint-disable no-new */
new Vue({
  router,
  store,
  securedAxiosInstance,
  plainAxiosInstance,
  i18n,
  render: h => h(App)
}).$mount('#app')
